import { InteractionLogEntry } from '../../../types/interaction-log-data';
import { WisdomTranscriptMessage } from '../../../../api/api-client';
import { FlowLogEvent } from '../../../types/flow-log';

export enum ProblemSeverity {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export enum ProblemType {
  HIGH_QUEUE_DURATION = 'HIGH_QUEUE_DURATION',
  LEX_ERROR = 'LEX_ERROR',
  FLOW_EXECUTION_FAILURE = 'FLOW_EXECUTION_FAILURE',
  WISDOM_TIMEOUT = 'WISDOM_TIMEOUT',
  CUSTOMER_DISCONNECT = 'CUSTOMER_DISCONNECT',
  REPEATED_INPUT_FAILURE = 'REPEATED_INPUT_FAILURE',
  INPUT_TIMEOUT = 'INPUT_TIMEOUT',
  LEX_FALLBACK_INTENT = 'LEX_FALLBACK_INTENT',
  EXCESSIVE_HOLD_TIME = 'EXCESSIVE_HOLD_TIME',
  LAMBDA_INVOCATION_ISSUES = 'LAMBDA_INVOCATION_ISSUES',
  REPEATED_MESSAGE_PLAYBACK = 'REPEATED_MESSAGE_PLAYBACK',
  FLOW_MODULE_FAILURE = 'FLOW_MODULE_FAILURE',
  FLOW_EXECUTION_DELAY = 'FLOW_EXECUTION_DELAY',
  MISSING_FLOW_RESULTS = 'MISSING_FLOW_RESULTS'
}

export interface Problem {
  id: string;
  type: ProblemType;
  severity: ProblemSeverity;
  title: string;
  description: string;
  timestamp: string;
  source: 'IVR_LOG' | 'WISDOM_TRANSCRIPT' | 'FLOW_LOG';
  relatedData?: unknown;
  suggestions?: string[];
  index?: number;
}

export interface ProblemDetectionContext {
  logs: InteractionLogEntry[];
  wisdomMessages: WisdomTranscriptMessage[];
  flowLogs?: FlowLogEvent[];
}
